import * as React from 'react'

export const Testimonial = () => {
  return (
    <div className='AI__testimonial'>
      <div className='container'>
        <div className='AI__client'>
          <h4>ลูกค้าของเรา</h4>

          <div className='AI__client__feature'>
            <img
              src='/images/ai/clients/homepro.png'
              srcSet='/images/ai/clients/homepro@2x.png 2x'
              alt='Home Pro'
              loading='lazy'
            />
            <img
              src='/images/ai/clients/jsw.png'
              srcSet='/images/ai/clients/jsw@2x.png 2x'
              alt='JSW'
              loading='lazy'
            />
          </div>

          {/* <p>Other development consult projects</p>

          <div className='AI__client__list'>
            <img
              src='/images/ai/clients/agoda.png'
              srcSet='/images/ai/clients/agoda@2x.png 2x'
              alt='Agoda'
              loading='lazy'
            />
            <img
              src='/images/ai/clients/juwwa.png'
              srcSet='/images/ai/clients/juwwa@2x.png 2x'
              alt='Juwwa'
              loading='lazy'
            />
            <img
              src='/images/ai/clients/logoguide.png'
              srcSet='/images/ai/clients/logoguide@2x.png 2x'
              alt='Logoguide'
              loading='lazy'
            />
            <img
              src='/images/ai/clients/nanameue.png'
              srcSet='/images/ai/clients/nanameue@2x.png 2x'
              alt='Nanameue'
              loading='lazy'
            />
            <img
              src='/images/ai/clients/zort.png'
              srcSet='/images/ai/clients/zort@2x.png 2x'
              alt='Zort'
              loading='lazy'
            />
            <img
              src='/images/ai/clients/yay.png'
              srcSet='/images/ai/clients/yay@2x.png 2x'
              alt='Yay'
              loading='lazy'
            />
            <img
              src='/images/ai/clients/talkport.png'
              alt='Talkport'
              srcSet='/images/ai/clients/talkport@2x.png 2x'
              loading='lazy'
            />
            <img
              src='/images/ai/clients/learn.png'
              srcSet='/images/ai/clients/learn@2x.png 2x'
              alt='Learn'
              loading='lazy'
            />
          </div> */}
        </div>

        <div className='AI__certified'>
          <h4>Certified</h4>

          <div className='AI__certified__content'>
            <div className='AI__certified__imgs'>
              <img
                src='/images/ai/iso-ism.svg'
                alt='ISO/IEC 27001'
                loading='lazy'
              />
              <img
                src='/images/ai/iso-pim.svg'
                alt='ISO/IEC 27701'
                loading='lazy'
              />
            </div>
            <p>
              Data Wow ผ่านการอบรบพร้อมใบประกาศ มาตรฐาน ISO 27001 (Information
              Security) และ มาตรฐาน ISO 27701 (Privacy Information)
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
